import axios from 'axios'
// import setConfig from '@/config/axios-config'
// setConfig(axios)
const uaApi = '/kwClientService/ua'
let headers = {
  'Authorization': null
}
/**
 * 获取腾讯云IM临时凭证
 */
export const getIMTempCredentialApi = (params) => {
  return axios({
    url: uaApi + '/pt/common/getIMTempCredential',
    method: 'get',
    params: {
        ...params,
        loading: false,
        needToken: false
    },
    headers
  })
}
/*
  * 问题文案
  */
export const fetchConsultContent = (params) => {
    return axios({
        url: uaApi + '/question/copywriting',
        method: 'GET',
        params: {
            ...params,
            loading: false,
            needToken: false
        },
        headers
    })
}

/*
 * 搜索问题
 */
export const searchQuestion = (params) => {
  return axios({
      url: uaApi + '/question/searchQuestion',
      method: 'GET',
      params: {
          ...params,
          loading: false,
          needToken: false
      },
      headers
  })
}
/*
 * 问题详情
 */
export const searchQuestionDetail = (params) => {
    return axios({
        url: uaApi + '/question/detail',
        method: 'GET',
        params: {
            ...params,
            loading: false,
            needToken: false
        },
        headers
    })
}

/**
 * 获取字典
 * @param data
 */
export const getDictType = (params) => {
  return axios({
      url: uaApi + '/question/menus',
      method: 'GET',
      params: {
          ...params,
          loading: false,
          needToken: false
      },
      headers
  })
}
/**
 * 获取客服技能组配置
 */
export const getSkillGroupListApi = (params) => {
    return axios({
        url: uaApi + '/pt/common/getSkillGroupList',
        method: 'get',
        params: {
            ...params,
            loading: false,
            needToken: false
        },
        headers
    })
}

/**
 * 考生技能组关系绑定
 */
export const bindCandidateSkillGroupApi = (params) => {
    return axios({
        url: uaApi + '/pt/common/bindCadidateSkillGroup',
        method: 'get',
        params: {
            ...params,
            loading: false,
            needToken: false
        },
        headers
    })
}
  



// WEBPACK FOOTER //
// ./src/model/yks-customer-model.js